@if (dataLoaded()) {
  <app-survey-list-filter
    [questionnaires]="questionnaires"
    [groups]="groups"
    [surveyPlatforms]="surveyPlatforms"
    [questionnaireFormTypes]="questionnaireFormTypes"
    [rounds]="rounds"
    [surveyStatuses]="surveyStatuses"
    (search)="search($event)"
  ></app-survey-list-filter>
} @else {
  <span>Survey Filter Loading...</span>
}
